
export default {
  data() {
    return {
      title: this.$t('create_online_store_app'),
      description: this.$t('online_store_app_description'),
      sliderApps: [
        {
          title: this.$t('double_your_sales'),
          details: "",
          imageUrl: "/assets/images/store-app/slider-apps/01.png",
        },
        {
          title: this.$t('enhance_store_identity'),
          details: "",
          imageUrl: "/assets/images/store-app/slider-apps/02.png",
        },
        {
          title: this.$t('stay_close_to_customers'),
          details: "",
          imageUrl: "/assets/images/store-app/slider-apps/03.png",
        },
      ],
      builderFeatures: [
        {
          title: this.$t('full_control'),
          details: this.$t('control_interface_design'),
          imageUrl: "/assets/images/store-app/builder-app-features/01.png",
        },
        {
          title: this.$t('identity_customization'),
          details: this.$t('control_identity_colors'),
          imageUrl: "/assets/images/store-app/builder-app-features/02.png",
        },
        {
          title: this.$t('style_customization'),
          details: this.$t('control_style_sections'),
          imageUrl: "/assets/images/store-app/builder-app-features/03.png",
        },
        {
          title: this.$t('notification_control_system'),
          details: this.$t('send_schedule_notifications'),
          imageUrl: "/assets/images/store-app/builder-app-features/04.png",
        },
        {
          title: this.$t('quick_update'),
          details: this.$t('quick_publish_updates'),
          imageUrl: "/assets/images/store-app/builder-app-features/05.png",
        },
      ],
      sliderAppFeatures: [
        {
          title: this.$t('shopping_cart'),
          details: this.$t('add_manage_cart_purchase_tracking'),
          imageUrl: "/assets/images/store-app/slider-app-features/01.png",
        },
        {
          title: this.$t('online_payment'),
          details: this.$t('easy_checkout_payment'),
          imageUrl: "/assets/images/store-app/slider-app-features/02.png",
        },
        {
          title: this.$t('easier_product_browsing'),
          details: this.$t('customers_browse_products'),
          imageUrl: "/assets/images/store-app/slider-app-features/03.png",
        },
        {
          title: this.$t('order_tracking'),
          details: this.$t('track_orders_shipments'),
          imageUrl: "/assets/images/store-app/slider-app-features/04.png",
        },
        {
          title: this.$t('interactive_states'),
          details: this.$t('support_daily_new_states'),
          imageUrl: "/assets/images/store-app/slider-app-features/05.png",
        },
        {
          title: this.$t('popup_windows'),
          details: this.$t('show_promo_images_open_app'),
          imageUrl: "/assets/images/store-app/slider-app-features/06.png",
        },
        {
          title: this.$t('countdown_timer'),
          details: this.$t('engage_customers_countdown'),
          imageUrl: "/assets/images/store-app/slider-app-features/07.png",
        }
      ],
      sliderOurStoresApps: [
        {
          title: this.$t('weaver_design'),
          details: this.$t('weaver_design_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/08.png",
          iosUrl: "https://apps.apple.com/us/app/weaver-design-%D9%88%D9%8A%DA%A4%D8%B1-%D8%AF%D9%8A%D8%B2%D8%A7%D9%8A%D9%86/id1513176594",
          androidUrl: "https://play.google.com/store/apps/details?id=com.khtwah.weaverdesign",
        },
        {
          title: this.$t('beauty_10'),
          details: this.$t('beauty_10_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/09.png",
          iosUrl: "https://apps.apple.com/us/app/beauty-10-%D8%A8%D9%8A%D9%88%D8%AA%D9%8A-%D8%AA%D9%86/id1503350361",
          androidUrl: "https://play.google.com/store/apps/details?id=com.beauty.beautyten",
        },
        {
          title: this.$t('attar'),
          details: this.$t('attar_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/10.png",
          iosUrl: "https://apps.apple.com/sa/app/%D9%85%D8%AA%D8%AC%D8%B1-%D8%B9%D8%B7%D8%A7%D8%B1/id6449694998",
          androidUrl: "https://play.google.com/store/apps/details?id=com.matjrah.attar",
        },
        {
          title: this.$t('rahaty'),
          details: this.$t('rahaty_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/11.png",
          iosUrl: "https://apps.apple.com/sa/app/%D9%85%D8%AA%D8%AC%D8%B1-%D8%B1%D8%A7%D8%AD%D8%AA%D9%8A/id1498315789",
          androidUrl: "https://play.google.com/store/apps/details?id=com.khtwah.rahaty",
        },
        {
          title: this.$t('kanz_al_sahra'),
          details: this.$t('kanz_al_sahra_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/12.png",
          iosUrl: "https://apps.apple.com/us/app/%D9%83%D9%86%D8%B2-%D8%A7%D9%84%D8%B5%D8%AD%D8%B1%D8%A7%D8%A1-kanzalsahra/id1564098406",
          androidUrl: "https://play.google.com/store/apps/details?id=com.khtwah.kanzalsahra",
        },
        {
          title: this.$t('rosa'),
          details: this.$t('rosa_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/13.png",
          iosUrl: "https://apps.apple.com/sa/app/rosa-%D8%B1%D9%88%D8%B3%D8%A7/id6473897245",
          androidUrl: "https://play.google.com/store/apps/details?id=com.matjrah.rosa",
        },
        {
          title: this.$t('shubra_taif'),
          details: this.$t('shubra_taif_description'),
          imageUrl: "/assets/images/store-app/slider-our-stores-apps/14.png",
          iosUrl: "https://apps.apple.com/us/app/%D8%B4%D8%A8%D8%B1%D8%A7-%D8%A7%D9%84%D8%B7%D8%A7%D8%A6%D9%81/id1547601607",
          androidUrl: "https://play.google.com/store/apps/details?id=com.matjrah.shubra",
        },
      ],
      pricesTable: {
        header: {
          title: this.$t('app'),
          icon: "mdi-cellphone",
          desc: "",
        },
        content: [
          {
            title: this.$t('auto_sync_store_apps'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('instant_notification_system'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('app_control_panel'),
            basicText: this.$t('restricted_permissions'),
            growText: this.$t('full_permissions'),
          },
          {
            title: this.$t('select_from_designs'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('multiple_display_options'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('unlimited_banners'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('app_status_notifications'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('abandoned_cart_reminders'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('free_technical_support'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('order_tracking'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('apple_pay_card_support'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('favorites_feature'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('customer_location_map'),
            basic: true,
            grow: true,
          },
          {
            title: this.$t('font_customization'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('advanced_design_customization'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('deep_linking'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('countdown_timer_feature'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('popup_windows_feature'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('quick_shortcuts'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('notification_and_offer_bar'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('interactive_stories'),
            basic: false,
            grow: true,
          },
          {
            title: this.$t('integration_analytics_apps'),
            basic: false,
            grow: true,
          },
        ],
      },
    };
  },
  head() {
    return {
      title: this.title,
      description: this.description,
      keywords: this.$t('keywords'),

      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale",
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: "https://matjrah.com/store-app",
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: this.$t('matjrah'),
        },
        {
          hid: "og:updated_time",
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: "https://matjrah.com/matjrah.png",
        },
        {
          hid: "apple-mobile-web-app-title",
          name: "apple-mobile-web-app-title",
          content: this.title,
        },

        { name: "twitter:site", content: "@Matjrah" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://matjrah.com/store-app",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: "https://matjrah.com/matjrah.png",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://matjrah.com/store-app",
        },
      ],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          "headline": this.title,
          "description": this.description,
          "datePublished": '2022-10-14T10:10:00-07:00',
          "dateModified": '2022-10-14T10:10:00-07:00',
          "publisher": {
            "@type": "Organization",
            "name": this.$t('matjrah'),
            "logo": {
              "@type": "ImageObject",
              "url": "https://matjrah.com/matjrah.png",
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://matjrah.com/store-app"
          },
          "author": { "@type": "Person", "name": "matjrah" },
        }]
    }
  }
};
